import { JSX, ReactNode } from "react";
import { BaseComponent } from "../../Core/BaseComponent/BaseComponent";
import "./Styles.scss";

export class GridContainer extends BaseComponent<IGridContainerProps, IGridContainerState>
{
    public render(): JSX.Element
    {
        const {
            children,
            className = '',
            style = {},
            spacing = 3,
        } = this.props;

        const cssClasses: string[] = [];
        cssClasses.push('grid');
        cssClasses.push('grid__container');
        cssClasses.push(className);

        const mergedStyle = {
            '--grid-spacing': `${spacing * 8}px`,
            ...style,
        } as React.CSSProperties;

        return (
            <div
                {...this.props}
                className={cssClasses.filter(i => !!i).join(' ')}
                style={mergedStyle}
            >
                {children}
            </div>
        );
    }
}

export interface IGridContainerProps extends React.HTMLAttributes<HTMLDivElement>
{
    spacing?: number;
}

export interface IGridContainerState { }
